import { gkApi } from './index';

const crewDeliveryApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    listOpenCrewDeliveries: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/crew-delivery/open/`,
        method: 'get',
        params: { limit: 500 },
      }),
    }),
    listLastCrewDeliveries: builder.query({
      query: ({ eventId, lastN }) => ({
        url: `/event/${eventId}/crew-delivery/last/${lastN}/`,
        method: 'get',
      }),
    }),
    getCrewDeliveryDetails: builder.query({
      query: (delId) => ({
        url: `/crew-delivery/${delId}/`,
        method: 'get',
      }),
    }),
    getCrewDeliveryPdf: builder.query({
      query: (delId) => ({
        url: `/crew-delivery/${delId}/pdf/`,
        method: 'get',
        responseHandler: (response) => response.blob(),
      }),
    }),
    // Net confirmed-delivered quantities per destination/article — i.e. what is
    // currently at each location and therefore available to return (Retoure).
    getDeliveredQuantities: builder.query({
      query: ({ eventId, destinationIds } = {}) => {
        const params = new URLSearchParams();
        if (eventId) params.append('event_id', eventId);
        (destinationIds || []).forEach((d) =>
          params.append('destination_ids', d)
        );
        return {
          url: `/crew-delivery/delivered/?${params.toString()}`,
          method: 'get',
        };
      },
    }),
    createCrewDelivery: builder.mutation({
      query: (payload) => ({
        url: '/crew-delivery/',
        method: 'post',
        body: payload,
      }),
    }),
    confirmCrewDelivery: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/crew-delivery/${id}/confirm/`,
        method: 'post',
        body: payload,
      }),
    }),
    cancelCrewDelivery: builder.mutation({
      query: ({ id }) => ({
        url: `/crew-delivery/${id}/cancel/`,
        method: 'post',
      }),
    }),

    // --- Crew-delivery article templates (event-scoped) ---
    listCrewDeliveryTemplates: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/crew-delivery/templates/`,
        method: 'get',
      }),
      providesTags: ['CREW_DELIVERY_TEMPLATE_LIST'],
    }),
    createCrewDeliveryTemplate: builder.mutation({
      query: ({ eventId, ...body }) => ({
        url: `/event/${eventId}/crew-delivery/templates/`,
        method: 'post',
        body,
      }),
      invalidatesTags: ['CREW_DELIVERY_TEMPLATE_LIST'],
    }),
    updateCrewDeliveryTemplate: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/crew-delivery/templates/${id}/`,
        // Uppercase 'PATCH' is required: the Fetch spec does not normalize the
        // method casing for PATCH, and a lowercase value breaks the CORS
        // preflight cache in Chromium.
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['CREW_DELIVERY_TEMPLATE_LIST'],
    }),
    deleteCrewDeliveryTemplate: builder.mutation({
      query: ({ id }) => ({
        url: `/crew-delivery/templates/${id}/`,
        method: 'delete',
      }),
      invalidatesTags: ['CREW_DELIVERY_TEMPLATE_LIST'],
    }),
  }),
});

export const {
  useListOpenCrewDeliveriesQuery,
  useListLastCrewDeliveriesQuery,
  useCreateCrewDeliveryMutation,
  useGetCrewDeliveryDetailsQuery,
  useGetCrewDeliveryPdfQuery,
  useLazyGetCrewDeliveryPdfQuery,
  useGetDeliveredQuantitiesQuery,
  useConfirmCrewDeliveryMutation,
  useCancelCrewDeliveryMutation,
  useListCrewDeliveryTemplatesQuery,
  useCreateCrewDeliveryTemplateMutation,
  useUpdateCrewDeliveryTemplateMutation,
  useDeleteCrewDeliveryTemplateMutation,
} = crewDeliveryApi;
